import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { QueryResponse } from './response-templates/query-response';
import { CourseResponse } from './models/course-response';
import { CommandResponse } from './response-templates/command-response';
import { ProgressResponse } from './models/progress-response';
import { TraineeInvite } from '../../../trainee/models/trainee-invite.model';
import { TraineeOverview } from './models/trainee-list-response';
import { EmailExistsResult } from '../../ui/utils/email-exists-validator/email-exists-validator.service';
import { TraineeAdapted } from '../../../trainee/models/trainee-list.model';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private http = inject(HttpClient);


  getDashboard(culture: string) {
    return this.http.get<QueryResponse<CourseResponse>>(
      environment.api.course,
      {
        params: {
          culture: culture,
        },
      },
    );
  }

  getTraineeProgress() {
    return this.http.get<QueryResponse<ProgressResponse>>(
      environment.api.progress.trainee,
    );
  }

  saveQuizProgress(moduleId: number, culture: string) {
    return this.http.post<CommandResponse<CourseResponse>>(
      environment.api.progress.quizAnswered,
      {},
      {
        params: {
          culture: culture,
          moduleId,
        },
      },
    );
  }
  saveVideoProgress(videoId: number, culture: string) {
    return this.http.post<CommandResponse<CourseResponse>>(
      environment.api.progress.videoWatched,
      {},
      {
        params: {
          culture: culture,
          videoId,
        },
      },
    );
  }

  downloadCertificate(levelId: number, culture: string, forUser?: string) {
    return this.http.post(
      environment.api.downloadCertificate,
      { forUser, culture, levelId },
      { responseType: 'blob' },
    );
  }

  downloadCertificateViaTraineeList(
    level: string,
    traineeGuid: string,
    culture: string,
  ) {
    return this.http.post(
      environment.api.downloadCertificate, //-this needs to change to new api waiting for this
      { level, traineeGuid, culture },
      { responseType: 'blob' },
    );
  }

  inviteTrainee(trainee: TraineeInvite) {
    return this.http.post<CommandResponse>(
      environment.api.identity.understandingdyslexia.saveTrainee,
      trainee,
    );
  }

  getTraineeList() {
    return this.http.get<QueryResponse<TraineeOverview>>(
      environment.api.identity.understandingdyslexia.list,
    );
  }

  deleteTrainee(trainee: TraineeAdapted) {
    return this.http.post<CommandResponse>(
      environment.api.identity.understandingdyslexia.delete,
      { id: trainee.id },
    );
  }

  reinvite(trainee: TraineeAdapted) {
    return this.http.post<CommandResponse<EmailExistsResult>>(
      environment.api.identity.understandingdyslexia.reinvite,
      { id: trainee.id },
    );
  }

  emailExists(email: string) {
    return this.http.post<CommandResponse<EmailExistsResult>>(
      environment.api.identity.accountUser.emailExists,
      {
        email,
      },
    );
  }
}
